import SectionHeader from '@/components/base/SectionHeader';
import AnimeCard from '@/components/base/AnimeCard';
import { getHotAnime } from '@/mocks/anime';

export default function FeaturedAnime() {
  const hotAnime = getHotAnime().slice(0, 6);

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <SectionHeader
          title="热门推荐"
          subtitle="大家都在看的爆款番剧"
          linkTo="/categories"
          linkLabel="查看全部"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotAnime.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>
      </div>
    </section>
  );
}